import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import api, { setAuthHandlers } from '../services/api';

const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      accessToken: null,
      refreshToken: null,
      isAuthenticated: false,
      isLoading: false,
      login: async (email, password) => {
        set({ isLoading: true });
        try {
          const { data } = await api.post('/auth/login', { email, password });
          set({ user: data.user, accessToken: data.accessToken, refreshToken: data.refreshToken, isAuthenticated: true, isLoading: false });
          return { success: true };
        } catch (err) {
          set({ isLoading: false });
          return { success: false, error: err.response?.data?.error || 'Anmeldefehler' };
        }
      },
      logout: async () => {
        try { await api.post('/auth/logout', { refreshToken: get().refreshToken }); } catch {}
        set({ user: null, accessToken: null, refreshToken: null, isAuthenticated: false });
      },

      // Nach erfolgreichem Refresh: neue Token übernehmen, Anmeldung behalten.
      setTokens: ({ accessToken, refreshToken }) =>
        set({ accessToken, refreshToken, isAuthenticated: true }),

      // Abmelden ohne Serveraufruf – für den Fall, dass der Refresh scheitert.
      forceLogout: () =>
        set({ user: null, accessToken: null, refreshToken: null, isAuthenticated: false }),
    }),
    {
      name: 'praenatal-auth',
      partialize: (state) => ({ user: state.user, accessToken: state.accessToken, refreshToken: state.refreshToken, isAuthenticated: state.isAuthenticated }),
    }
  )
);

export default useAuthStore;

// Verbindet Store und Interceptor, ohne dass api.js den Store importieren muss -
// das wäre ein Ringschluss, weil der Store api.js schon importiert.
setAuthHandlers({
  getRefreshToken: () => useAuthStore.getState().refreshToken,
  onRefreshed: (daten) => useAuthStore.getState().setTokens(daten),
  onFailure: () => useAuthStore.getState().forceLogout(),
});
